import { forwardRef, useImperativeHandle } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { gql } from 'graphql-request'
import { useNavigate } from 'react-router-dom'

import { useMutation } from '@hooks/graphql'
import Button from '@components/Button'
import TutorCombobox from '@components/Tutors/TutorCombobox'
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form'
import { Input } from '@/components/ui/input'

const CREATE_EDUCATOR_PROJECT_MUTATION = gql`
  mutation createEducatorProject($input: CreateEducatorProjectInput!) {
    createEducatorProject(input: $input) {
      educatorProject {
        id
        name
        createdAt
        updatedAt
      }
      errors {
        message
      }
    }
  }
`

const ManualCreationStep = forwardRef(({ id }, ref) => {
  const navigate = useNavigate()

  const { mutate: createEducatorProject, isLoading: isCreating } = useMutation({
    gqlMutation: CREATE_EDUCATOR_PROJECT_MUTATION,
    onSuccess: data => navigate(`/educators/projects/${data.createEducatorProject.educatorProject.id}`)
  })

  const form = useForm({
    defaultValues: {
      name: '',
      tutor: null
    }
  })

  const submit = (values) => {
    createEducatorProject({ input: { seriesId: id, name: values.name, tutorId: values.tutor?.id } })
  }

  // Expose the submit handler via the ref with the name createLesson
  useImperativeHandle(ref, () => ({
    createLesson: form.handleSubmit(submit)
  }))

  return (
    <Form {...form}>
      <form className='flex flex-col'>
        <h2 className='text-2xl font-medium mb-1'>Configure your lesson</h2>
        <p className='text-l text-gray-600 mb-5 font-light'>
          Name your lesson and optionally add an AI tutor to provide personalized guidance to students. Leave unselected for independent work.
        </p>

        <div className='mb-3'>
          <FormField
            control={form.control}
            name="name"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Lesson Name</FormLabel>
                <FormControl>
                  <Input placeholder='Write a name for your lesson' {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>

        <div className='mb-5'>
          <FormField
            control={form.control}
            name="tutor"
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <TutorCombobox
                    value={field.value}
                    onChange={field.onChange}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
      </form>
    </Form>
  )
})

export default ManualCreationStep
